"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormFieldSelector = _interopRequireDefault(require("./FormFieldSelector"));

var _CreateButton = _interopRequireDefault(require("./CreateButton"));

var FormFieldAddOptions =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(FormFieldAddOptions, _Component);
  (0, _createClass2.default)(FormFieldAddOptions, null, [{
    key: "propTypes",
    get: function get() {
      return {
        enabled: _react.PropTypes.bool.isRequired
      };
    }
  }]);

  function FormFieldAddOptions() {
    var _this;

    (0, _classCallCheck2.default)(this, FormFieldAddOptions);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FormFieldAddOptions).call(this));
    _this.state = {
      isAddingNewFormField: false
    };
    _this.toggleIsAddingNewFormField = _this.toggleIsAddingNewFormField.bind((0, _assertThisInitialized2.default)(_this));
    _this.stopAddingNewFormField = _this.stopAddingNewFormField.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(FormFieldAddOptions, [{
    key: "langKey",
    value: function langKey(key) {
      return "leadFlowEditor.formFieldEditor." + key;
    }
  }, {
    key: "toggleIsAddingNewFormField",
    value: function toggleIsAddingNewFormField() {
      this.setState({
        isAddingNewFormField: !this.state.isAddingNewFormField
      });
    }
  }, {
    key: "stopAddingNewFormField",
    value: function stopAddingNewFormField() {
      this.setState({
        isAddingNewFormField: false
      });
    }
  }, {
    key: "renderAddButtons",
    value: function renderAddButtons() {
      var enabled = this.props.enabled;
      return _react.default.createElement(_CreateButton.default, {
        labelLangKey: this.langKey('addNewFormField'),
        disabledLangKey: this.langKey('fieldLimitReachedMessage'),
        enabled: enabled,
        onClick: this.toggleIsAddingNewFormField
      });
    }
  }, {
    key: "renderFieldSelector",
    value: function renderFieldSelector() {
      return _react.default.createElement(_FormFieldSelector.default, {
        onClick: this.stopAddingNewFormField
      });
    }
  }, {
    key: "render",
    value: function render() {
      var isAddingNewFormField = this.state.isAddingNewFormField;
      return _react.default.createElement("div", {
        className: "form-field-add-options"
      }, isAddingNewFormField ? this.renderFieldSelector() : this.renderAddButtons());
    }
  }]);
  return FormFieldAddOptions;
}(_react.Component);

exports.default = FormFieldAddOptions;
module.exports = exports.default;